import { render, staticRenderFns } from "./PropertyLocation.vue?vue&type=template&id=72201682&"
import script from "./PropertyLocation.vue?vue&type=script&lang=js&"
export * from "./PropertyLocation.vue?vue&type=script&lang=js&"
import style0 from "./PropertyLocation.vue?vue&type=style&index=0&id=72201682&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports